package com.example.mystybag.communication.login

import com.example.mystybag.communication.Communication.sendCommand
import com.example.mystybag.sharedmodels.AllCommands.COMMAND_GET_WELCOME_IMAGES
import com.example.mystybag.sharedmodels.AllCommands.GET_CITIES
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.common.responseModels.GetWelcomeScreenConfigResponseModel
import com.example.mystybag.sharedmodels.project.requestModels.CheckUserExistsRequestModel
import com.example.mystybag.sharedmodels.project.requestModels.EnrollUserRequestModel
import com.example.mystybag.sharedmodels.project.requestModels.VerifyUserRequestModel
import com.example.mystybag.sharedmodels.project.responseModels.CheckUserExistsResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.EnrollUsrResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.GetCitiesResponseModel

object LoginCommands {
    suspend fun sendGetCities() = sendCommand(BaseRequestModel(api = GET_CITIES), BaseRequestModel::class, GetCitiesResponseModel::class, BaseResponseModel::class)

    suspend fun sendCheckUserExists(request: CheckUserExistsRequestModel) = sendCommand(request, CheckUserExistsRequestModel::class, CheckUserExistsResponseModel::class, BaseResponseModel::class)

    suspend fun sendEnroll(request: EnrollUserRequestModel) = sendCommand(request, EnrollUserRequestModel::class, EnrollUsrResponseModel::class, BaseResponseModel::class)

    suspend fun sendVerifyUser(request: VerifyUserRequestModel) = sendCommand(request, VerifyUserRequestModel::class, BaseResponseModel::class, BaseResponseModel::class)
}